import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import _ from 'lodash';
import Moment from 'moment';
import StaticData from '../utils/staticData.json';
import StringUtil from '../utils/string';
import CustomForm from '../components/CustomFormGroup';

class CustomItems extends Component {
  /**
   * Renders items for a certain key.
   * @param {*} data - optional data
   * @param {String} key - key to render
   */
  renderItem = (data = null, key) => {
    data = data || this.state.data;
    let value = data[key];

    // Some custom validations common to all items like country, dates or cycles
    if (value && key === 'country') {
      value = _.find(StaticData.SELECT_DATA.COUNTRIES, item => item.key === value).value;
    }
    if (value && key === 'local_distribution_zone') {
      value = _.find(StaticData.LOCAL_DISTRIBUTION_ZONES, item => item.key === value).value;
    }
    if (value && key === 'billing_start_date') {
      value = (value && Moment(value).format('h:mm:ss A, DD MMMM YYYY')) || '-';
    }
    if (value && key === 'latest_reading.reading_date') {
      key = "Latest reading's date";
      value = (value && Moment(value).format('h:mm:ss A, DD MMMM YYYY')) || '-';
    }
    if (value && key === 'latest_reading.type') {
      key = "Latest reading's type";
    }
    if (value && key === 'latest_reading.amount') {
      key = 'Latest reading';
    }
    if (value && key === 'billing_cycle_multiplier') {
      key = 'billing_cycle';
      value += ` ${data.billing_cycle_unit}`;
    }
    if (value && key === 'billing_cycle_unit') {
      return null;
    }
    if (
      key === 'third_party_billing' ||
      key === 'group_bills' ||
      key === 'show_registration_code'
    ) {
      value = value ? 'Yes' : 'No';
    }
    if (value && key === 'type') {
      if (value === 'H') {
        value = 'Heat';
      }
      if (value === 'CW') {
        value = 'Cold water';
      }
      if (value === 'HW') {
        value = 'Hot water';
      }
      if (value === 'G') {
        value = 'Gas';
      }
      if (value === 'E') {
        value = 'Electricity';
      }
      if (value === 'CHW') {
        value = 'Cooling';
      }
      if (value === 'WW') {
        value = 'Waste water';
      }
    }

    return (
      <Col xs={12} sm={6} key={`${key}-item`}>
        <CustomForm
          header={StringUtil.capitalizeAndReplaceUnderscore(key)}
          placeholder={value}
          disabled
        />
      </Col>
    );
  };

  renderPropertyTextByType(property, type = '') {
    if (!type && property.type) {
      type = property.type;
    }
    let parts = [];
    if (type === 'apartment') {
      parts = [property.address_1, property.postcode];
    }
    if (type === 'building') {
      parts = [property.address_1, property.postcode];
    }
    if (type === 'development') {
      parts = [property.site_code, property.postcode];
    }

    return parts.filter(i => Boolean(i)).join(', ');
  }

  renderEventEntity(entity) {
    if (entity === 'apartment') {
      return 'Apartment';
    }
    if (entity === 'building') {
      return 'Building';
    }
    if (entity === 'building_apartments') {
      return 'Apartments in building';
    }
    if (entity === 'development') {
      return 'Development';
    }
  }

  renderPropertyType(type) {
    if (type === 'apartment') {
      return 'Apartment';
    }
    if (type === 'building') {
      return 'Building';
    }
    if (type === 'development') {
      return 'Development';
    }
  }

  renderBillState(state) {
    if (state === 'internal') {
      return 'Under internal review';
    }
    if (state === 'pending') {
      return 'Under review by managing agent';
    }
    if (state === 'rejected') {
      return 'Rejected';
    }
    if (state === 'approved') {
      return 'Approved';
    }
  }

  renderEventReason(reason) {
    if (reason === 'billing_cycle') {
      return 'Billing cycle';
    }
    if (reason === 'lease_end') {
      return 'Lease ended';
    }
    if (reason === 'sub_lease_end') {
      return 'Sub lease ended';
    }
    if (reason === 'credit_note') {
      return 'Credit note';
    }
  }
}

export default CustomItems;



// WEBPACK FOOTER //
// ./src/components/CustomItems.js